const Vue = window.Vue;

Vue.component("comp-download-card", {
  template: '[data-component="comp-download-card"]',
  data() {
    return {
      customerName: '',
      customerNumber: '',
      loading: false
    };
  },
  methods: {
    sanitizeNumberInput(event) {
      this.customerNumber = event.target.value.replace(/\D/g, '');
    },
    async downloadCard() {
      this.loading = true;
      try {
        const encodedName = encodeURIComponent(this.customerName);
        const encodedNumber = encodeURIComponent(this.customerNumber);
        const response = await fetch(`/rest/create-card/?customerName=${encodedName}&customerNumber=${encodedNumber}`);
        const contentLength = response.headers.get('Content-Length');
        console.log('Content-Length:', contentLength);

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error('Fehler vom Server: ' + errorText);
        }

        const blob = await response.blob();
        console.log('Blob-Größe:', blob.size);

        const disposition = response.headers.get('Content-Disposition');
        const filename = disposition?.match(/filename="(.+?)"/)?.[1] || 'Kundenkarte.pkpass';

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    }
  }
});
